// eslint-disable-next-line no-restricted-syntax
export enum PromotionActionLocation {
  PROMO_TAB = 'promoTab',
  QP_BOARD = 'qpBoard',
  QP_SLIP = 'qpSlip',
  CONTEST_DETAIL = 'contestDetail',
  CONTEST_ENTRIES = 'contestEntries',
  CONTEST_ENTRY_REVIVE = 'contestEntryRevive',
  HOME = 'home',
  SIGN_UP = 'signUp',
  DEPOSIT = 'deposit',
}

// eslint-disable-next-line no-restricted-syntax
export enum PromotionAnalyticsType {
  QP_BOOST = 'qpBoost',
  QP_VOUCHER = 'qpVoucher',
  CONTEST_VOUCHER = 'contestVoucher',
  GENERAL_VOUCHER = 'generalVoucher',
  DEPOSIT_BONUS = 'depositBonus',
}
